import { Component, OnInit, Output, ViewChild, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-transversales',
  templateUrl: './transversales.component.html',
  styleUrls: ['./transversales.component.css']
})
export class TransversalesComponent implements OnInit {

 


 
 
 


  @Output()
  sectorEsById = new EventEmitter<any>();

  @Output()
  backTo = new EventEmitter<any>();

  @Input() idSector:number;
  @Input() title: string;
  @Input() padre: number;
  @Input() tablaEstandar: boolean;
  @Input() marca: boolean;
  


  constructor() {
      this.idSector = 0;
      this.padre = 0;
   }

  ngOnInit(): void {

  }

 
  back(){
    window.location.reload();
 
  }
  home(){
    window.location.reload();
  }



}
